/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Space_Linked_Projects_CountInputs */



/**
* | output |
* | --- |
* | "{count} linked projects" |
*
* @param {Space_Linked_Projects_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const space_linked_projects_count = /** @type {((inputs: Space_Linked_Projects_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Space_Linked_Projects_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} verknüpfte Projekte`)
	return /** @type {LocalizedString} */ (`${i?.count} linked projects`)
});